
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18.01 18.01"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.004.01a.771.771 0 00-.771.77v7.453H.78a.771.771 0 00-.771.771.771.771 0 00.77.771h7.454v7.453a.771.771 0 00.77.771.771.771 0 00.772-.77V9.774h7.453a.771.771 0 00.77-.77.771.771 0 00-.77-.772H9.775V.78a.771.771 0 00-.771-.77z","font-family":"sans-serif","overflow":"visible"}})])
          )
        }
      }
    